'use client';

import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';

import { PlanOrderFlowData } from './model';

export const usePlanOrderingFlow = () => {
    const { modalData, openModal, isModalOpen, editModal } =
        useBrowserModalControls<PlanOrderFlowData['uidForModal']>('plan-order-flow');

    return {
        uidForModal: modalData,
        isPlanOrderFlowStarted: isModalOpen,
        startPlanOrderFlow: openModal,
        resetStartPlanOrderFlow: () => editModal(false),
    };
};
